module.exports = __webpack_public_path__ + "img/alipay.72ce2c21.png";